import script from "./Flag.vue?vue&type=script&setup=true&lang=js"
export * from "./Flag.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__